import { RefundApprover } from "../model";

export class RefundApproverPostCommand{
    refundApproverView:RefundApprover;

    constructor(refundApproverView:RefundApprover){
        this.refundApproverView = refundApproverView;
    }
}